/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module AviFormsModule */

import { Injector } from '@angular/core';

const $injector = '$injector';

export const stringGroupCollectionProvider = {
    deps: [$injector],
    provide: 'StringGroupCollection',
    useFactory(injector: Injector): any {
        return injector.get('StringGroupCollection');
    },
};
